import type { ReactNode } from "react";
import { useAuthStore } from "../store/authStore";

export { useAuthStore };

export function useAuth() {
  return useAuthStore();
}

/** Passthrough — auth state lives in Zustand, no provider needed. */
export function AuthProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
